import React, {Component, PropTypes} from 'react';
import { RequiredLabel } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './select-element.style.js';

export class SelectElement extends Component {
  render() {
    const { isRequired, label, options, id, onChange, disabled, defaultValue, errors, showErrors, css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');

    return (
      <div className={css.group}>
        <RequiredLabel
          hasErrors={hasErrors && showErrors}
          htmlFor={id}
          content={label}
          isRequired={isRequired}/>
        <select
          id={id}
          className={css.select}
          disabled={disabled}
          defaultValue={defaultValue}
          onChange={e => onChange(e.target.value, true)}
          aria-required={isRequired}
          aria-invalid={hasErrors && showErrors}
          aria-describedby={errorIds}>
          <option value="">-- Select --</option>
          {options.map(option => (
            <option
              key={`${id}-${option.value}`}
              className={css.option}
              value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

SelectElement.propTypes = {
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.any,
  defaultValue: PropTypes.number,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool
};

export default styleable(defaultStyle) (SelectElement);




// WEBPACK FOOTER //
// src/common/form-elements/select-element-folder/select-element.js